/** Chat deep-link: t.me for usernames, tg://user for bare telegram ids. */
export function telegramChatUrl(
	username?: string,
	telegramId?: number,
): string | null {
	if (username) return `https://t.me/${username}`
	if (telegramId) return `tg://user?id=${telegramId}`
	return null
}
